import z from "zod";
import { CartStore } from "./commerce/cart.store";
import { OrderStore } from "./commerce/order.store";
import { StripeStore } from "./commerce/stripe.store";

export function amountToMinorUnits(amount:number, minorUnitsPerMajorUnit: number = 100): number {
    if(!Number.isFinite(amount)) throw new Error("Amount is not a valid number");

    const scaled = amount * minorUnitsPerMajorUnit;
    const rounded = scaled >= 0 ? Math.floor(scaled + 0.5) : Math.ceil(scaled - 0.5);

    if(!Number.isSafeInteger(rounded)) throw new Error("Amount is out of safe integer range");

    return rounded;
}
export function amountToDecimalUnits(amountInMinorUnits: number, minorUnitsPerMajorUnit: number = 100): number {
    if(!Number.isSafeInteger(amountInMinorUnits)) throw new Error("Amount is not a valid safe integer");
    const decimalValue = amountInMinorUnits / minorUnitsPerMajorUnit;
    return decimalValue;
}

export function getCartStore(): CartStore {
    return window.Alpine.store('cart') as CartStore;
}
export function getOrderStore() : OrderStore {
    return window.Alpine.store('order') as OrderStore;
}
export function getStripeStore(): StripeStore {
    return window.Alpine.store('stripe') as StripeStore;
}
export const microtask = (): Promise<void> => Promise.resolve();


export function flattenObjectPaths(schema: z.ZodObject<any>): string[] {
  const out: string[] = [];

  const walk = (obj: z.ZodObject<any>, prefix?: string) => {
    const shape = obj.shape;
    if (prefix) out.push(prefix);

    for (const [key, child] of Object.entries(shape)) {
      const next = prefix ? `${prefix}.${key}` : key;
      out.push(next);

      // Only recurse if the child is directly a ZodObject
      if (child instanceof z.ZodObject) {
        walk(child, next);
      }
    }
  };

  walk(schema);
  return out;
}

export function getValueByPath<T extends object>(obj: T, path: string): unknown {
  return path.split('.').reduce((acc: any, key) => {
    if (acc && typeof acc === 'object' && key in acc) {
      return acc[key];
    }
    return undefined;
  }, obj);
}
export function getShapeByPath<T extends object>(obj: T, path: string): unknown {
  return path.split('.').reduce((acc: any, key) => {
    if (acc && typeof acc === 'object' && "shape" in acc && key in acc.shape) {
      return acc.shape[key];
    }
    return undefined;
  }, obj);
}